import http from '@/http-common';

class VersionService {
  async get() {
    return http.get('/version/');
  }

  async getAbout() {
    return http.get('/version/sobre');
  }
}

export default new VersionService();
